import { compose } from 'recompose';
import ClientsTasksItem from './clientsTasksItem';


const enhance = compose(
);

export default enhance(ClientsTasksItem);
